import classNames from "classnames";
import PropTypes from "prop-types";
import { components } from "react-select";
import { memo, useEffect } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

import "./LocationMenuChip.scss";

const LocationMenuChip = ({ children, className, ...props }) => {
	const { selectProps } = props;

	useEffect(() => {
		const selectedEl = document.getElementsByClassName("location-menu-chip")[0];

		if (selectedEl) {
			selectedEl.scrollTo(0, 0);
		}
	}, [selectProps?.inputValue]);

	return (
		<components.MenuList
			{...props}
			className={classNames("location-menu-chip", "location-menu-list", className)}
		>
			{selectProps?.locationMenuLabel && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="location-menu-list__top-departure-cities-label"
				>
					{selectProps.locationMenuLabel}
				</Typography>
			)}
			<div
				className={classNames(
					"location-menu-list__container",
					"location-menu-chip__container"
				)}
			>
				{children}
			</div>
		</components.MenuList>
	);
};

LocationMenuChip.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	selectProps: PropTypes.object,
};

export default memo(LocationMenuChip);
